<script setup lang="ts">
interface Props {
  value?: boolean | undefined;
  classSummary?: String | string | undefined;
  ignoreSummaryClick?: boolean | undefined;
  [x: string]: any;
}

const props = withDefaults(defineProps<Props>(), {
  ignoreSummaryClick: false
});

const slots = useSlots();

const emit = defineEmits(['click', 'toggle']);
const model = defineModel<boolean>({ required: false, default: false });

const init = (): void => {
  if ((props.value !== undefined) && (model.value !== true))
    model.value = props.value;
};
onMounted(init);

const onSummaryClick = (e: MouseEvent): void => {
  if (props.ignoreSummaryClick)
    e.preventDefault(); // Prevent from default behavior
  else
    model.value = (! model.value);
};

const onToggle = (e: Event): void => {
  const detailsElement = e.target as HTMLDetailsElement;
  model.value = detailsElement.open;
  emit('toggle', e);
};

// Expose usefull functions
defineExpose({ init });
</script>

<template>
  <details
    :open="model"
    @click="(e: Event) => emit('click', e)"
    @toggle="onToggle">
    <summary
      v-show="slots.summary"
      :class="[
        ((! ignoreSummaryClick) && 'cursor-pointer'),
        classSummary
      ]"
      @click="onSummaryClick">
      <slot
        name="summary"
        :value="model" />
    </summary>
    <slot :value="model" />
  </details>
</template>

<style lang="scss" scoped>
details {
  //@apply open:animate-[down-fade-in_1s_ease-in-out]; Use class name instead!!!

  >summary {
    //list-style: none;
    @apply list-none;

    /* Latest Chrome, Edge, Firefox */
    &::marker,
    /* Safari */
    &::-webkit-details-marker {
      @apply hidden;
    }
  }
}
</style>
